import { urlConfig } from '@/config';
import { useAuthContext } from '@/contexts/auth-context';
import { favoriteStore } from '@/models/stores';
import type { Deal } from '@/models/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const useRemoveFromFavorites = ({
  dealId,
  dealShortId,
}: {
  dealId: Deal['id'];
  dealShortId: Deal['short_id'];
}) => {
  const queryClient = useQueryClient();
  const { user } = useAuthContext();
  const removeFromFavoritesMutation = useMutation({
    onMutate: async () => {
      // Mutate in Favorite store
      favoriteStore.remove(dealId);
    },
    mutationFn: async () => {
      const response = await fetch(
        `${urlConfig.paddockFxRestApiUrl}/deals/${dealId}/favorites/delete`,
        // /deals/:id/favorites/delete
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${user?.accessToken}`,
          },
        },
      );

      if (!response.ok) {
        throw new Error('Failed to create task');
      }

      return response.json();
    },
    onSuccess: () => {
      // const realTaskPersistedToBackend = data;
      // setDialogIsOpen(false);
      // tasksStore.replaceTask(task.id, realTaskPersistedToBackend);
      // setOptimisticCreateTaskId(generateOptimisticId());
      // // UX NOTE: we want to assign the task to the deal immediately after it is created
      // // so that the user can see the task in the deal immediately
      // assignTaskMutation.mutate({
      //   task: {
      //     id: realTaskPersistedToBackend.id,
      //     title: realTaskPersistedToBackend.title,
      //     description: realTaskPersistedToBackend.description,
      //   },
      // });
    },
    onError: (error) => {
      console.error('Failed to create favorite', error);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['favorites'] });
      queryClient.invalidateQueries({ queryKey: ['deal', dealShortId] });
    },
  });

  return removeFromFavoritesMutation;
};

export default useRemoveFromFavorites;
